var _path, _path2, _path3, _path4, _path5, _path6, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoicePageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.75H3.25V3.25H4V1.75ZM17 17.5V18.25C17.4142 18.25 17.75 17.9142 17.75 17.5H17ZM5 17.5H4.25C4.25 17.9142 4.58579 18.25 5 18.25V17.5ZM16.25 5.5V17.5H17.75V5.5H16.25ZM17 16.75H5V18.25H17V16.75ZM4 3.25H10.5V1.75H4V3.25ZM10.5 3.25H14V1.75H10.5V3.25ZM5.75 17.5V7H4.25V17.5H5.75ZM17.75 5.5C17.75 3.42893 16.0711 1.75 14 1.75V3.25C15.2426 3.25 16.25 4.25736 16.25 5.5H17.75Z",
    fill: "#525D71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5V8.25H5.75V7.5H5ZM2 7.5H1.25C1.25 7.91421 1.58579 8.25 2 8.25V7.5ZM4.25 4V7.5H5.75V4H4.25ZM5 6.75H2V8.25H5V6.75ZM2.75 7.5V4H1.25V7.5H2.75ZM3.5 3.25C3.91421 3.25 4.25 3.58579 4.25 4H5.75C5.75 2.75736 4.74264 1.75 3.5 1.75V3.25ZM3.5 1.75C2.25736 1.75 1.25 2.75736 1.25 4H2.75C2.75 3.58579 3.08579 3.25 3.5 3.25V1.75Z",
    fill: "#525D71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5H14",
    stroke: "#525D71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5H14",
    stroke: "#525D71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.5H14",
    stroke: "#525D71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.5H11",
    stroke: "#525D71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 5.5,
    r: 1,
    fill: "#525D71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicePageIcon);
export default __webpack_public_path__ + "static/media/invoice-page-icon.b73c9395d5945b3471ea82e652a0ca6e.svg";
export { ForwardRef as ReactComponent };